import React, { Component } from 'react'
import Grid from '@mui/material/Grid'
import { connect } from 'react-redux'
import { withRouter } from 'react-router-dom'
import Card from '@mui/material/Card'
import Box from '@mui/material/Box'
import Button from '@mui/material/Button'
import Typography from '@mui/material/Typography'
import _ from 'lodash'
import classNames from 'classnames'

import styles from './VisaoPorAuditor.module.css'
import VisaoPorAuditorItensAcessadosCard from './VisaoPorAuditorItensAcessadosCard'
import MenuFiltrosSelecaoServidor from './MenuFiltrosSelecaoServidor'
import { recuperarOpcoesAuditor } from '../../../actions/itensActions'
import ItemContextMenu from '../../util/ItemContextMenu'
import VisaoPorAuditorProcessosCard from './VisaoPorAuditorProcessosCard'
import VisaoPorAuditorDocumentosCard from './VisaoPorAuditorDocumentosCard'
import VisaoPorAuditorComunicacoesCard from './VisaoPorAuditorComunicacoesCard'
import VisaoPorAuditorProcessosAdmCard from './VisaoPorAuditorProcessosAdmCard'
import VisaoPorAuditorDocsPendentesJuntada from './VisaoPorAuditorDocsPendentesJuntada'
import {
  sistemas,
  visualizarUrlSistemaLinksPrincipais,
  viusalizarUrlSistemaInstrucaoRepresentacao,
  VISAO_PROCESSOS_ADM_POR_UNIDADE_AGRUPADOR
} from '../../../controllers/itensController'
import VisaoPorAuditorDocumentosQueAtuei from './VisaoPorAuditorDocumentosQueAtuei'
import VisaoPorAuditorProcessosAdmQueAtuei from './VisaoPorAuditorProcessosAdmQueAtuei'
import PesquisarPorNumeroCompletoCard from '@sesol-3/gerencial-lib/dist/components/dialogs/PesquisarPorNumeroCompletoCard'
import VisaoPorAuditorProcessosQueInstrui from './VisaoPorAuditorProcessosQueInstrui'
import VisaoPorAuditorProcessosCEQueAtuei from './VisaoPorAuditorProcessosCEQueAtuei'
import { grey } from '@mui/material/colors'

export class VisaoPorAuditor extends Component {
  constructor(props) {
    super(props)
    this.state = {
      expandedHistory: false
    }
  }

  handleIndicadorComponentClick(
    indicador,
    destaque,
    target = '_blank',
    sistema = sistemas.processos
  ) {
    const {
      filtros: { responsabilidadeUnidade },
      itens: {
        visao: {
          informacoesAuditor: { codigoUnidadeIntegracao }
        }
      }
    } = this.props
    const indicadorJSON = JSON.stringify(indicador)
    const destaqueJSON = destaque ? JSON.stringify(destaque) : null
    const urlParams =
      `?redirectTo=/${sistema.uri}/detalhar&visao=visaoPorAuditorAgrupador&codigoUnidadeAtual=${codigoUnidadeIntegracao}`.concat(
        `&responsabilidadeUnidade=${responsabilidadeUnidade}&indicador=${indicadorJSON}&destaque=${destaqueJSON}`
      )
    const callback = (url) => window.open(`${url}${urlParams}`, target)
    visualizarUrlSistemaLinksPrincipais(sistema.id, callback)
  }

  handleMenuServidores() {
    const {
      filtros: { unidadesAtuais, responsabilidadeUnidade }
    } = this.props
    this.props.recuperarOpcoesAuditor(unidadesAtuais, responsabilidadeUnidade, true)
  }

  handleIndicadorComponentItemContextMenuOpen(
    event,
    { indicador, destaque },
    sistema = sistemas.processos
  ) {
    event.preventDefault()
    this.setState({
      indicadorComponentContextMenuAnchorEl: event.currentTarget,
      indicador,
      destaque,
      sistema
    })
  }

  handleIndicadorComponentItemContextMenuClose() {
    this.setState({
      indicadorComponentContextMenuAnchorEl: null,
      indicador: null,
      destaque: null,
      sistema: null
    })
  }

  handleIndicadorComponentItemContextMenuItemClick(target) {
    const { indicador, destaque, sistema } = this.state
    this.handleIndicadorComponentClick(indicador, destaque, target, sistema)
    this.handleIndicadorComponentItemContextMenuClose()
  }

  handleVisaoItemClick(visao, idSistema) {
    const {
      filtros: { responsabilidadeUnidade },
      unidadesUsuario: {
        unidadeVinculacaoHierarquica: { codigoUnidade }
      }
    } = this.props
    const urlParams = `?redirectTo=/visao/${visao}&codigoUnidadeAtual=${codigoUnidade}&responsabilidadeUnidade=${responsabilidadeUnidade}`
    const callback = (url) => window.open(`${url}${urlParams}`, '_blank')
    visualizarUrlSistemaLinksPrincipais(idSistema, callback)
  }

  renderServidorCard() {
    const {
      itens: {
        visao: { informacoesAuditor }
      },
      unidadesUsuario: { fotoUsuario }
    } = this.props
    const hasPhotoProfile = !_.isNil(fotoUsuario) && !_.isEmpty(fotoUsuario)
    return (
      <Card elevation={1} style={{ borderRadius: '18px', position: 'relative' }}>
        <Grid container spacing={2} className={styles.containerDadosFotos}>
          {hasPhotoProfile && (
            <Grid item sm={4}>
              <img
                className={styles.fotoAuditor}
                alt={informacoesAuditor.nome}
                src={`data:image/jpeg;base64,${fotoUsuario}`}
              />
            </Grid>
          )}
          <Grid item sm={hasPhotoProfile ? 8 : 12}>
            <Typography variant='body1' gutterBottom>
              {informacoesAuditor.nome}
            </Typography>
            <Typography variant={'body2'} color='textSecondary' gutterBottom>
              {informacoesAuditor.email}
            </Typography>
            <Typography variant={'body2'} color='textSecondary' gutterBottom>
              {informacoesAuditor.descricaoFuncaoFormatada}
            </Typography>
            <Typography variant={'body2'} color='textSecondary'>
              <Button
                className={styles.buttonNumeroProcesso}
                id={`button-processo-${_.camelCase(informacoesAuditor.nomeCompletoLotacao)}`}
                color='primary'
                onClick={() =>
                  this.handleVisaoItemClick(
                    VISAO_PROCESSOS_ADM_POR_UNIDADE_AGRUPADOR,
                    sistemas.processos.id
                  )
                }>
                {informacoesAuditor.lotacao}
              </Button>
            </Typography>
          </Grid>
        </Grid>
        <Grid container style={{ backgroundColor: grey[100], padding: '8px 16px' }}>
          <MenuFiltrosSelecaoServidor
            radioGroupRow
            handleMenuOnEnter={() => this.handleMenuServidores()}
          />
        </Grid>
      </Card>
    )
  }

  handleBoxTotalRepresentacoesPendentesAutuacaoClick() {
    const urlParams = `&redirectTo=/autuacao`
    const callback = (url) => window.open(`${url}${urlParams}`, '_blank')
    viusalizarUrlSistemaInstrucaoRepresentacao(callback)
  }

  renderRepresentacoesPendentesAutuacao() {
    const {
      unidadesUsuario: { totalRepresentacoesPendentesAutuacao }
    } = this.props
    return totalRepresentacoesPendentesAutuacao !== null ? (
      <Card elevation={1} style={{ borderRadius: '18px', position: 'relative', marginTop: '16px' }}>
        <Box p={2}>
          <Box display='flex' alignContent='center'>
            <Box display='flex' alignItems='center' width='calc(100% - 68px)'>
              <Typography
                variant='body1'
                color='textPrimary'
                className={styles.titleDocmentosPendeteJuntada}>
                Representações pendentes de autuação
              </Typography>
            </Box>
            <Box
              style={{ cursor: 'pointer' }}
              className={classNames(styles.totalBox, styles.totalDocPendentes)}
              onClick={() => this.handleBoxTotalRepresentacoesPendentesAutuacaoClick()}>
              <Typography
                variant='body2'
                color='white'
                style={{ textAlign: 'center', fontWeight: '100', fontSize: '1.45rem' }}>
                {totalRepresentacoesPendentesAutuacao}
              </Typography>
            </Box>
          </Box>
        </Box>
      </Card>
    ) : (
      ''
    )
  }

  render() {
    const { indicadorComponentContextMenuAnchorEl } = this.state
    const {
      itens: {
        visao: { historicosItensAcessadosUsuario }
      }
    } = this.props
    return (
      <Grid item lg={11} xl={11}>
        <Grid container spacing={2} justifyContent='flex-start'>
          <Grid item sm={4} lg={3}>
            {this.renderServidorCard()}
            <VisaoPorAuditorDocsPendentesJuntada />
            {this.renderRepresentacoesPendentesAutuacao()}
          </Grid>
          <Grid item sm={8} lg={9}>
            <Grid container spacing={2} alignItems='stretch'>
              <Grid item lg={7} xs={12}>
                <VisaoPorAuditorItensAcessadosCard
                  historicosItensAcessadosUsuario={historicosItensAcessadosUsuario}
                />
              </Grid>
              <Grid item lg={5} xs={12}>
                <Card style={{ borderRadius: '14px', padding: '8px 16px' }}>
                  <PesquisarPorNumeroCompletoCard />
                </Card>
              </Grid>
              <Grid item xs={12}>
                <VisaoPorAuditorProcessosCard
                  handleIndicadorComponentClick={this.handleIndicadorComponentClick.bind(this)}
                  handleIndicadorComponentItemContextMenuOpen={this.handleIndicadorComponentItemContextMenuOpen.bind(
                    this
                  )}
                />
              </Grid>
              <Grid item xs={12}>
                <VisaoPorAuditorProcessosAdmCard
                  handleIndicadorComponentClick={this.handleIndicadorComponentClick.bind(this)}
                  handleIndicadorComponentItemContextMenuOpen={this.handleIndicadorComponentItemContextMenuOpen.bind(
                    this
                  )}
                />
              </Grid>
              <Grid item xs={12}>
                <VisaoPorAuditorDocumentosCard
                  handleIndicadorComponentClick={this.handleIndicadorComponentClick.bind(this)}
                  handleIndicadorComponentItemContextMenuOpen={this.handleIndicadorComponentItemContextMenuOpen.bind(
                    this
                  )}
                />
              </Grid>
              <Grid item xs={12}>
                <VisaoPorAuditorComunicacoesCard
                  handleIndicadorComponentClick={this.handleIndicadorComponentClick.bind(this)}
                  handleIndicadorComponentItemContextMenuOpen={this.handleIndicadorComponentItemContextMenuOpen.bind(
                    this
                  )}
                />
              </Grid>
              <Grid item xs={12}>
                <VisaoPorAuditorProcessosQueInstrui />
              </Grid>
              <Grid item xs={12}>
                <VisaoPorAuditorProcessosCEQueAtuei />
              </Grid>
              <Grid item xs={12}>
                <VisaoPorAuditorProcessosAdmQueAtuei />
              </Grid>
              <Grid item xs={12}>
                <VisaoPorAuditorDocumentosQueAtuei />
              </Grid>
            </Grid>
          </Grid>
        </Grid>
        <ItemContextMenu
          itemContextMenuAnchorEl={indicadorComponentContextMenuAnchorEl}
          handleItemContextMenuClose={this.handleIndicadorComponentItemContextMenuClose.bind(this)}
          handleItemContextMenuItemClick={this.handleIndicadorComponentItemContextMenuItemClick.bind(
            this
          )}
        />
      </Grid>
    )
  }
}

const mapStateToProps = ({ filtros, itens, unidadesUsuario }) => ({
  filtros,
  itens,
  unidadesUsuario
})

const reduxEnhanced = connect(mapStateToProps, { recuperarOpcoesAuditor })(VisaoPorAuditor)

export default withRouter(reduxEnhanced)
